#import "../fragments/ai-email-template.graphql"

mutation RegenerateAiEmailTemplateFromTemplate(
    $input: AiEmailTemplateRegenerateFromTemplateInput!
) {
    aiEmailTemplateRegenerateFromTemplate(input: $input) {
        campaign {
            ...AiEmailTemplate
        }
    }
}
